export default "__VITE_ASSET__56585fc5__"